import styled from 'styled-components';

import { neutral } from 'theme/colors';
import { space } from 'theme/sizes';

import { toRem } from 'utils/mixins';

export const Wrapper = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(249, 250, 251, 0.5);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(8.9px);
  -webkit-backdrop-filter: blur(8.9px);

  .inner-pop {
    position: relative;
    background-color: ${neutral.neu03};
    padding: ${space.m};
    max-width: ${toRem(300)};

    button {
      position: absolute;
      top: ${space.xxs};
      right: ${space.xxs};
    }
  }
`;
